import { useStore } from 'zustand'
import { useEditorStore } from '../store/editor'

// 响应式获取 undo/redo 可用性（订阅 zundo temporal store）。
export function useHistory() {
  const past = useStore(useEditorStore.temporal, (s) => s.pastStates.length)
  const future = useStore(useEditorStore.temporal, (s) => s.futureStates.length)
  return { canUndo: past > 0, canRedo: future > 0 }
}
